'use strict';

function ContactMap(options, mapElement, templateUrl, hrefRoute) {
	this.mapElement = mapElement;
	this.templateUrl = templateUrl;
	this.hrefRoute = hrefRoute;

	//default options
	this.options = {
		'zoomLvl': 15,
		'mapType': 'roadmap'
	};

	//voeg input opties samen met default opties
	for (var attrname in options) {
		this.options[attrname] = options[attrname];
	}

	this.menuElements = new Array();
	this.catSlugs = new Array();

	switch (this.options.type) {
		case 'voorzieningen':
			//setup classes
			this.mapElement.classList.add('loading');

			this.updateNavigation = this.updateNavigation.bind(this);

			this.parseVoorzieningen = this.parseVoorzieningen.bind(this);
			this.parseVoorzieningenRequest = new XMLHttpRequest();
			this.parseVoorzieningenRequest.addEventListener('readystatechange', this.parseVoorzieningen);

			var url = 'ajax/get_voorzieningen.php';

			if (typeof this.templateUrl == 'string') {
				var url = this.templateUrl + '/' + url;
			}

			this.parseVoorzieningenRequest.open('POST', url);
			this.parseVoorzieningenRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

			this.parseVoorzieningenRequest.send();
			break;
		case 'coordinaten':
			this.location = { lat: this.options.location[0], lng: this.options.location[1] };
			this.setupMap();
			break;
		case 'adres':
		default:
			if (google) {
				var _this = this;
				this.geocoder = new google.maps.Geocoder();
				if (Array.isArray(this.options.location)) {
					for (var i = 0; i < this.options.location.length; i++) {
						this.geocoder.geocode({ 'address': this.options.location[i] }, function (results, status) {
							_this.parseGeo(results, status);
						});
					}
				} else {
					this.geocoder.geocode({ 'address': this.options.location }, function (results, status) {
						_this.parseGeo(results, status);
					});
				}
			} else {
				console.warn('De Google Maps api is niet ingeladen.');
			}
			break;
	}
}

ContactMap.prototype.parseVoorzieningen = function () {
	if (this.parseVoorzieningenRequest.readyState != 4) return;
	if (this.parseVoorzieningenRequest.status != 200 && this.parseVoorzieningenRequest.status != 304) {
		console.log('HTTP error ' + this.parseVoorzieningenRequest.status);
		return;
	}

	if (!this.parseVoorzieningenRequest.responseText) {
		this.onError('Kan voorzieningen data niet ophalen');
	}

	this.mapElement.classList.remove('loading');

	this.voorzieningenData = JSON.parse(this.parseVoorzieningenRequest.responseText);

	this.setupVoorzieningenMap();
};

ContactMap.prototype.parseGeo = function (results, status) {
	if (status == 'OK') {
		if (Array.isArray(this.options.location)) {
			if (!this.location) {
				this.location = new Array();
			}
			this.location.push(results[0].geometry.location);
			if (this.location.length == this.options.location.length) {
				this.setupMap();
			}
		} else {
			this.location = results[0].geometry.location;
			this.setupMap();
		}
	} else {
		this.mapElement.parentNode.removeChild(this.mapElement);
	}
};

ContactMap.prototype.setupMap = function () {
	if (!Array.isArray(this.location)) {
		var defaultLocation = this.location;
	}

	if (this.options.streetview) {
		this.googleMap = new google.maps.StreetViewPanorama(this.mapElement, {
			position: defaultLocation,
			pov: { heading: this.options.streetviewHeader, pitch: this.options.streetviewPitch },
			zoom: 0.4,
			disableDefaultUI: true,
			zoomControl: false,
			fullscreenControl: false,
			scrollwheel: false,
			zoomControlOptions: false,
			linksControl: false,
			addressControl: false,
			panControl: false,
			panControlOptions: false,
			motionTracking: false,
			motionTrackingControl: false,
			clickToGo: false,
			disableDoubleClickZoom: true,
			showRoadLabels: false
		});

		return;
	}

	var image = {
		url: this.templateUrl + '/images/marker.png',
		scaledSize: new google.maps.Size(40, 55.5),
		anchor: new google.maps.Point(20, 55.5)
	};

	if (this.options.mapType == 'roadmap') {
		var styles = [{
			"featureType": "poi",
			"elementType": "labels",
			"stylers": [{ "visibility": "off" }]
		}, {
			"stylers": [{ "lightness": 30 }, { "saturation": -30 }, { "gamma": 0.8 }]
		}, {
			"featureType": "landscape" }];

		var styledMap = new google.maps.StyledMapType(styles, { name: "Styled Map" });
	}

	var mapOptions = {
		zoom: this.options.zoomLvl,
		disableDefaultUI: false,
		scrollwheel: false,
		mapTypeControl: false,
		streetViewControl: false,
		draggable: false,
		panControl: true,
		fullscreenControl: false,
		center: defaultLocation,
		mapTypeId: this.options.mapType
	};
	this.googleMap = new google.maps.Map(this.mapElement, mapOptions);

	if (this.options.mapType == 'roadmap') {
		this.googleMap.mapTypes.set('map_style', styledMap);
		this.googleMap.setMapTypeId('map_style');
	}

	var _this = this;

	if (Array.isArray(this.location)) {
		var bounds = new google.maps.LatLngBounds();

		for (var i = 0; i < this.location.length; i++) {
			bounds.extend(this.location[i]);

			var marker = new google.maps.Marker({
				position: this.location[i],
				map: this.googleMap,
				icon: image
			});
		}
		this.googleMap.fitBounds(bounds);
	} else {

		var marker = new google.maps.Marker({
			position: this.location,
			map: this.googleMap,
			icon: image
		});
		google.maps.event.addListener(marker, 'click', function () {
			window.open(_this.hrefRoute + '?daddr=' + _this.options.location, '_blank');
		});
	}

	if (this.options.constructionLocation) {
		var mapItems = this.createSiteOverlay(this.options.constructionLocation, this.options.cLocationNorth, this.options.cLocationSouth, this.options.cLocationWest, this.options.cLocationEast);

		if (mapItems) {
			for (var _i = 0; _i < mapItems.length; _i++) {
				if (mapItems[_i]) {
					mapItems[_i].setMap(this.googleMap);
				}
			}
		}
	}

	if (this.options.centerLocation) {
		var _mapItems = this.createSiteOverlay(this.options.centerLocation.imageSrc, this.options.centerLocation.coordNorth, this.options.centerLocation.coordSouth, this.options.centerLocation.coordWest, this.options.centerLocation.coordEast, {
			url: this.templateUrl + '/images/marker-centrum.png',
			scaledSize: new google.maps.Size(40, 40),
			anchor: new google.maps.Point(20, 20)
		});

		if (_mapItems) {
			for (var _i2 = 0; _i2 < _mapItems.length; _i2++) {
				if (_mapItems[_i2]) {
					_mapItems[_i2].setMap(this.googleMap);
				}
			}
		}
	}
};

ContactMap.prototype.setupVoorzieningenMap = function () {
	if (this.options.mapType == 'roadmap') {
		var styles = [{
			"featureType": "poi",
			"elementType": "labels",
			"stylers": [{ "visibility": "off" }]
		}, {
			"stylers": [{ "lightness": 30 }, { "saturation": -30 }, { "gamma": 0.8 }]
		}, {
			"featureType": "landscape" }];

		var styledMap = new google.maps.StyledMapType(styles, { name: "Styled Map" });
	}

	var mapOptions = {
		zoom: this.options.zoomLvl,
		disableDefaultUI: false,
		scrollwheel: false,
		mapTypeControl: false,
		streetViewControl: false,
		//panControl: true,
		center: new google.maps.LatLng(this.voorzieningenData[0].latitude, this.voorzieningenData[0].longitude),
		mapTypeId: this.options.mapType
	};
	this.googleMap = new google.maps.Map(this.mapElement, mapOptions);

	if (this.options.mapType == 'roadmap') {
		this.googleMap.mapTypes.set('map_style', styledMap);
		this.googleMap.setMapTypeId('map_style');
	}

	var navigationElement = this.createNavigation();
	if (navigationElement.nodeType == 1) {
		this.mapElement.appendChild(navigationElement);
	}

	var latLngBounds = new google.maps.LatLngBounds();
	var _this = this;
	for (var i = 0; i < this.voorzieningenData.length; i++) {
		var image = {
			url: this.templateUrl + '/images/marker-' + this.voorzieningenData[i].terms[0].slug + '.png',
			scaledSize: new google.maps.Size(40, 40),
			anchor: new google.maps.Point(20, 20)
		};

		this.voorzieningenData[i].marker = new google.maps.Marker({
			position: new google.maps.LatLng(this.voorzieningenData[i].latitude, this.voorzieningenData[i].longitude),
			map: this.googleMap,
			icon: image
		});

		this.voorzieningenData[i].markerActive = true;

		this.voorzieningenData[i]['infowindow'] = new google.maps.InfoWindow({
			content: this.voorzieningenData[i].titel
		});

		google.maps.event.addListener(this.voorzieningenData[i].marker, 'click', function (e) {
			_this.displayInfoWindow(this);
		});
	}

	this.updateNavigation();

	for (var i = 0; i < this.voorzieningenData.length; i++) {
		if (this.voorzieningenData[i].markerActive) {
			latLngBounds.extend(new google.maps.LatLng(this.voorzieningenData[i].latitude, this.voorzieningenData[i].longitude));
		}
	}

	if (this.options.constructionLocation) {
		var mapItems = this.createSiteOverlay(this.options.constructionLocation, this.options.cLocationNorth, this.options.cLocationSouth, this.options.cLocationWest, this.options.cLocationEast);

		if (mapItems) {
			for (var _i3 = 0; _i3 < mapItems.length; _i3++) {
				mapItems[_i3].setMap(this.googleMap);
				if (mapItems[_i3] && mapItems[_i3].position) {
					latLngBounds.extend(mapItems[_i3].position);
				}
			}
		}
	}

	if (this.options.centerLocation) {
		var _mapItems2 = this.createSiteOverlay(this.options.centerLocation.imageSrc, this.options.centerLocation.coordNorth, this.options.centerLocation.coordSouth, this.options.centerLocation.coordWest, this.options.centerLocation.coordEast, {
			url: this.templateUrl + '/images/marker-centrum.png',
			scaledSize: new google.maps.Size(40, 40),
			anchor: new google.maps.Point(20, 20)
		});

		if (_mapItems2) {
			for (var _i4 = 0; _i4 < _mapItems2.length; _i4++) {
				if (_mapItems2[_i4]) {
					_mapItems2[_i4].setMap(this.googleMap);
					if (_mapItems2[_i4] && _mapItems2[_i4].position) {
						latLngBounds.extend(_mapItems2[_i4].position);
					}
				}
			}
		}
	}

	this.googleMap.fitBounds(latLngBounds);
};

ContactMap.prototype.createSiteOverlay = function (overlaySrc, north, south, west, east, markerImage) {
	if (!overlaySrc && typeof overlaySrc != 'string') {
		return false;
	}

	if (!markerImage) {
		var markerImage = {
			url: this.templateUrl + '/images/marker.png',
			scaledSize: new google.maps.Size(40, 55.5),
			anchor: new google.maps.Point(20, 55.5)
		};
	}

	var marker = false;

	if (this.options.type == 'voorzieningen') {
		var markerLat = Math.abs((north + south) / 2);
		var markerLong = Math.abs((east + west) / 2);

		marker = new google.maps.Marker({
			position: new google.maps.LatLng(markerLat, markerLong),
			icon: markerImage
		});
	}

	var imageBounds = {
		north: north,
		south: south,
		east: east,
		west: west
	};

	var overlay = new google.maps.GroundOverlay(overlaySrc, imageBounds);

	return [overlay, marker];
};

ContactMap.prototype.createNavigation = function () {
	var navigationElement = document.createElement('nav');
	navigationElement.setAttribute('class', 'kaart-navigation-wrapper');

	var navigationMenuElement = document.createElement('ul');
	navigationMenuElement.setAttribute('class', 'kaart-navigation');

	var cats = new Array();

	var referenceSlugs = [];
	for (var i = 0; i < this.voorzieningenData.length; i++) {
		for (var j = 0; j < this.voorzieningenData[i].terms.length; j++) {
			if (referenceSlugs.indexOf(this.voorzieningenData[i].terms[j].slug) < 0) {
				cats.push({
					'id': this.voorzieningenData[i].terms[j].term_id,
					'slug': this.voorzieningenData[i].terms[j].slug,
					'name': this.voorzieningenData[i].terms[j].name
				});
			}
			referenceSlugs.push(this.voorzieningenData[i].terms[j].slug);
		}
	}

	for (var _i5 = 0; _i5 < cats.length; _i5++) {
		var navigationMenuItemElement = document.createElement('li');
		navigationMenuItemElement.setAttribute('class', 'kaart-navigation-menu-item voorziening-cat-' + cats[_i5].slug);
		if (this.options.activeCategories) {
			for (var _j = 0; _j < this.options.activeCategories.length; _j++) {
				if (cats[_i5].id == this.options.activeCategories[_j].id) {
					navigationMenuItemElement.classList.add('is-active');
					break;
				}
			}
		} else if (_i5 == 0) {
			navigationMenuItemElement.classList.add('is-active');
		}
		navigationMenuItemElement.setAttribute('data-category', cats[_i5].slug);

		var navigationMenuButtonElement = document.createElement('button');
		navigationMenuItemElement.appendChild(navigationMenuButtonElement);

		navigationMenuButtonElement.addEventListener('click', this.updateNavigation);

		var labelElement = document.createElement('span');
		labelElement.setAttribute('class', 'kaart-navigation-menu-item-label');
		labelElement.appendChild(document.createTextNode(cats[_i5].name));

		navigationMenuItemElement.appendChild(labelElement);

		this.menuElements.push(navigationMenuItemElement);

		navigationMenuElement.appendChild(navigationMenuItemElement);
	}

	navigationElement.appendChild(navigationMenuElement);

	return navigationElement;
};

ContactMap.prototype.updateNavigation = function (e) {
	if (e && e.target) {
		var target = e.target;
		while (target && target.nodeName != 'LI') {
			target = target.parentNode;
		}

		target.classList.toggle('is-active');
	}

	for (var i = 0; i < this.voorzieningenData.length; i++) {
		this.voorzieningenData[i].marker.setMap(null);
		this.voorzieningenData[i].markerActive = false;
	}

	for (var i = 0; i < this.voorzieningenData.length; i++) {
		for (var j = 0; j < this.menuElements.length; j++) {
			var found = false;
			for (var k = 0; k < this.voorzieningenData[i].terms.length; k++) {
				if (this.voorzieningenData[i].terms[k].slug == this.menuElements[j].getAttribute('data-category') && this.menuElements[j].classList.contains('is-active')) {
					found = true;
				}
			}
			if (found) {
				this.voorzieningenData[i].marker.setMap(this.googleMap);
				this.voorzieningenData[i].markerActive = true;
			}
		}
	}
};

ContactMap.prototype.displayInfoWindow = function (e) {
	if (e && e.target) {
		var target = e.target;
	} else if (e && e.srcElement) {
		var target = e.srcElement;
	} else {
		//aanmame is marker
		var marker = e;
	}

	if (target) {
		if (target.nodeType != 1 && (target.nodeName != 'LI' || target.nodeName != 'SELECT')) {
			return false;
		}

		if (target.nodeName == 'SELECT') {
			var locationId = target.value;
		} else {
			while (!target.getAttribute('data-location-id')) {
				target = target.parentNode;
			}
			var locationId = target.getAttribute('data-location-id');
		}

		for (var i = 0; i < this.voorzieningenData.length; i++) {
			this.voorzieningenData[i].infowindow.close();
			if (locationId == this.voorzieningenData[i].id) {
				this.map.setZoom(15);
				this.map.panTo(this.voorzieningenData[i].marker.position);
				this.voorzieningenData[i].infowindow.open(this.map, this.voorzieningenData[i].marker);
			}
		}
	} else if (marker) {
		for (var i = 0; i < this.voorzieningenData.length; i++) {
			this.voorzieningenData[i].infowindow.close();
			if (marker == this.voorzieningenData[i].marker) {
				this.voorzieningenData[i].infowindow.open(this.map, this.voorzieningenData[i].marker);
			}
		}
	}
};